import { Inject, Injectable } from '@angular/core';
import { SESSION_STORAGE, WebStorageService } from 'ngx-webstorage-service';
import { labelsES } from './text/es';
import { labelsEN } from './text/en';
import { res } from './text/res';
import { CatalogDetInfo } from '../model/dictionary/CatalogDetInfo';
import { Organization } from '../model/Organization';
import { Store } from '../model/Store';

@Injectable()
export class Strings {

    /*Properties */
    private tenantId: number;
    private availableOrganization: Organization[];
    private availableStores: Store[];
    /*End properties*/

    constructor(
        @Inject(SESSION_STORAGE) private storage: WebStorageService
    ) { 
        this.getTenant();
        this.getAvailableOrganizations();
        this.getAvailableStores();
    }

    public init(){
        this.setTenant();
        this.setAvailableStores();
        this.setAvailableOrganizations();
    }
    
    public GetText(StringId: res): string {
        let response = '';
        const language = this.storage.get('catDetLanguageId');
        if (language == CatalogDetInfo.catDetCountryUSAId) {
            response = labelsEN.get(StringId);
        } else {
            response = labelsES.get(StringId);
        }
        return response;
    }

    public getLanguageIsSpanish() {
        let response = true; // true -> Spanish
        const language = this.storage.get('catDetLanguageId');
        if (language == CatalogDetInfo.catDetCountryUSAId) {
            response = false;
        }
        return response;
    }

    public getUSAStore() {
        let response = false; // false -> Mexico
        const isUSA = this.storage.get('catDetCountryId');
        if (isUSA == CatalogDetInfo.catDetCountryUSAId ) {
            response = true;
        }
        return response;
    }

    public getTenant() {
        this.setTenant();
        return this.tenantId;
    }

    public getAvailableOrganizations() {
        this.setAvailableOrganizations();
        return this.availableOrganization;
    }

    public getAvailableStores() {
        this.setAvailableStores();
        return this.availableStores;
    }

    public setTenant() {
        return this.tenantId = this.storage.get('tenantId');
    }

    public setAvailableOrganizations() {
        return this.availableOrganization = this.storage.get('availableOrganizations');
    }

    public setAvailableStores() {
        return this.availableStores = this.storage.get('availableStores');
    }
    public getAvailableTenants() {
        return this.storage.get('availableTenants');
    }

    public getLanguage() : string {
        const language = this.storage.get('catDetLanguageId');
        if (language == CatalogDetInfo.catDetCountryUSAId) {
            return "en";
        }
        else {
            return "es";
        }
    }
}
